define('modules/products/activation/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Activation = BaseView.extend({
        template: require("ldsh!./template"),
        serviceName: null,
        initialize: function(options) {
            var currentOptions = options || {};
            var serviceName = currentOptions.serviceName || "mdirector";
            this.serviceName = serviceName;
            this.isMdirector = (serviceName.toLowerCase() === "mdirector");
            if (this.model) {
                this.listenTo(this.model, "reset sync request error", this.render);
            }
        },
        serialize: function() {
            return {
                model: this.model,
                serviceName: this.serviceName,
                isMdirector: this.isMdirector
            };
        }
    });

    module.exports = Activation;
});

